export async function requestImages (uid, requestIdent, requestTitle) {
    const formData = new FormData();
    formData.append("uid", uid)
    formData.append("ident", requestIdent)
    formData.append("title", requestTitle)
    const response = await fetch('./google-image-search/request.php', {
      method: 'POST',
      //headers: {
      //  'Content-type': 'text/html'
      //},
      body: formData
    });
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    const data = await response.text();
    //console.log('Images:', data);
    if(data == '2'){
      return false;
    }
    else{
      return {__html: data}
    }

  }